// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonMerchantAccount__container .sui-react-select__single-value{display:inline}", "",{"version":3,"sources":["webpack://src/components/season/SeasonMerchantAccount/SeasonMerchantAccount.scss"],"names":[],"mappings":"AACE,kEACE,cAAA","sourcesContent":[".SeasonMerchantAccount__container {\n  .sui-react-select__single-value {\n    display: inline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
